import { CookieInformation } from './CookieInformation';
export default CookieInformation;
